import type { FC } from 'react';

import type { CommonAclsPrefix } from '../../ducks/common_acls/types';
import EntityAclsPanel from '../../panels/entity_acls/entity_acls';
import PageBlock from '../../ui/page_block/page_block';

import styles from './admin_acls_tab.module.css';

type Props = {
  title: string;
  subtitle: string;
  objectId: string;
  aclsType: CommonAclsPrefix;
};

const AdminAclsTab: FC<Props> = ({ title, subtitle, objectId, aclsType }) => (
  <div className={styles.root}>
    <PageBlock title={title}>
      <div>{subtitle}</div>
      <EntityAclsPanel objectId={objectId} aclsType={aclsType} />
    </PageBlock>
  </div>
);

export default AdminAclsTab;
